import React, { useState, createContext, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  encryptData,
  getDecryptedSessionStorageVariable,
} from '../../utils/encryptStorage'
import { toast } from 'react-toastify'

export const MyContext = createContext()

const AdminContext = ({ children }) => {
  const navigate = useNavigate()

  const [userData, setUserData] = useState({
    fleetId: getDecryptedSessionStorageVariable('fleetId') || '',
    firstName: getDecryptedSessionStorageVariable('firstName') || '',
    lastName: getDecryptedSessionStorageVariable('lastName') || '',
  })

  const setUserDataAndSessionStorage = useCallback((data) => {
    console.log('data', data)
    const { fleetId, firstName, lastName, fleetMobileNumber, token } = data
    setUserData({
      fleetId,
      firstName,
      lastName,
      fleetMobileNumber,
      token,
    })

    sessionStorage.setItem('fleetId', encryptData(fleetId))
    sessionStorage.setItem('firstName', encryptData(firstName))
    sessionStorage.setItem('lastName', encryptData(lastName))
    sessionStorage.setItem('fleetMobileNumber', encryptData(fleetMobileNumber))
    sessionStorage.setItem('token', token)
  }, [])

  const login = useCallback(
    async (userData) => {
      const { fleetId, firstName, lastName, fleetMobileNumber, token } =
        userData

      await setUserDataAndSessionStorage({
        fleetId,
        firstName,
        lastName,
        fleetMobileNumber,
        token,
      })
      navigate('/cab-booking-report')
      toast.success('Login successfully')
    },
    [navigate, setUserDataAndSessionStorage]
  )

  const logout = useCallback(() => {
    setUserData({
      fleetId: '',
      firstName: '',
      lastName: '',
      fleetMobileNumber: '',
    })

    sessionStorage.clear()
    navigate('/signin')
  }, [navigate])

  const checkValidity = useCallback(() => {
    return !!userData.fleetId
  }, [userData.fleetId])

  const auth = {
    userData,
    login,
    logout,
    checkValidity,
  }

  const [promoState, setPromoState] = useState('')
  const [refetchMobileAndNameCustomer, setRefetchMobileAndNameCustomer] =
    useState()
  return (
    <MyContext.Provider
      value={{
        refetchMobileAndNameCustomer,
        setRefetchMobileAndNameCustomer,
        auth,
        promoState,
        setPromoState,
        userData,
      }}
    >
      {children}
    </MyContext.Provider>
  )
}

export default AdminContext
